import numberWithCommas from '../../utils/numberWithCommas';

const ExchangeRate = ({ rates }) => {
  return (
    <>
      <h3>Conversion Rate</h3>
      {rates.map((rate) => (
        <div key={rate.id}>
          {numberWithCommas(rate.source)}{' '}
          <strong className={rate.sourceCode === 'LP' ? 'exchange-unit-linkpoints' : null}>
            {rate.sourceUnit}
          </strong>{' '}
          = {numberWithCommas(rate.destination)}{' '}
          <strong className={rate.destinationCode === 'LP' ? 'exchange-unit-linkpoints' : null}>
            {rate.destinationUnit}
          </strong>
        </div>
      ))}
    </>
  );
};

export default ExchangeRate;
